import arrowRight_Lines from './arrowRight_Lines.svg';
import arrowRightSolid_Lines from './arrowRightSolid_Lines.svg';

const comboIcons = {
  arrowRight_Lines,
  arrowRightSolid_Lines,
};

export default comboIcons;
